<template>
  <div class="container mt-6">
    <security-datatable />
  </div>
</template>

<script>
import {
  get,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import SecurityDatatable from "./security_datatable/Index.vue";

export default {
  name: "ApiManager",
  components: { SecurityDatatable },
  data() {
    return {
      apis: [],
    };
  },
  computed: {},
  methods: {
    init() {
      let v = this;
      get("/api/manage", {})
        .then((r) => {
          // console.log("modules", r);
          v.apis = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    install_api(rpt) {
      let v = this;
      put("/api/install", { name: rpt.name, pth: rpt.api_path })
        .then(() => {
          success_message(v.$t("api installed"));
          v.init();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    uninstall_api(rpt) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to uninstall this api?"),
        v,
        () => {
          del("/api/install", { uuid: rpt.uuid })
            .then(() => {
              success_message(v.$t("api uninstalled"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    permissions(mdle) {
      let v = this;
      v.$refs.permissions_modal.show_modal(mdle.module_id);
    },
    create() {
      let v = this;
      v.$refs.create_modal.show_modal();
    },
  },
  mounted() {
    let v = this;
    v.init();
  },
};
</script>

<style></style>
